module.exports = __webpack_public_path__ + "img/search-document.6e739276.svg";